import { augmentAction } from './augment-action.mjs';
import config from './config.mjs';

if (config.error) {
  console.error('WoopraConfigError', config.error); // eslint-disable-line no-console
} else {
  const { meta, ...options } = config;

  const _queue = window.__woo || window._w;
  if (_queue) {
    for (const instanceName in _queue) {
      if (_queue.hasOwnProperty(instanceName)) {
        window[instanceName].config({
          augment_action: augmentAction,
          ...options
        });
      }
    }
  }
}
